import React from "react";
import { useRecoilState } from "recoil";
import { licenseState } from "../../state/QuoteState";
import SummaryItem from "../../components/SummaryItem";
import CustomDivider from "../../components/CustomDivider";

const LicenseSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [
    {
      day,
      licenseCode,
      licenseType,
      month,
      year,
      haveCurrentInsurance,
      coverClaimFreeYears: coverClaimFreeYear,
      theftClaimFreeYears: theftClaimFreeYear,
    },
  ] = useRecoilState(licenseState);
  return (
    <>
      <SummaryItem items={[licenseType, licenseCode]} onEdit={onEdit}>
        License deatils
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[`${day}-${month}-${year}`]} onEdit={onEdit}>
        Issue Year
      </SummaryItem>
      <CustomDivider />
      <SummaryItem
        items={[
          haveCurrentInsurance
            ? "Have current insurance"
            : "Does not have current insurance",
        ]}
        onEdit={onEdit}
      >
        Insurance details
      </SummaryItem>
    </>
  );
};

export default LicenseSummary;
